import { TActionType, TransactionType } from "../../../Utility/Tracking/DataSet/Transaction";
import { trackTransaction } from "../../../Utility/Tracking/TrackingHelpers/Transaction";
import { IGameState } from "../../Game/IGameState";
import { showPopup } from "../../UI/UIStateHelper";
import { ILivesActionPayload } from "../PlayerActions";
import { setLives } from "../PlayerInventoryHelper";

export function receiveLives(state: IGameState, payload: ILivesActionPayload) {
    state = {
        ...state,
        playerState: setLives(
            state.playerState,
            state.playerState.lives + payload.lives
        ),
    };
    trackTransaction(state, TransactionType.REWARD, TActionType.REWARD);
    if (payload.showPopup) {
        state.UIState = showPopup(
            state.UIState,
            payload.popupParams.popup || 'receiveLivesMenu',
            {
                ...payload.popupParams,
                lives: payload.lives,
            }
        );
    }
    return state;
}
